import React from 'react';
import { Link } from 'react-router-dom';

const base =
  'type-button inline-flex items-center justify-center transition-colors duration-200 text-sm disabled:opacity-50';

const variants = {
  gradient:
    `${base} rounded-input px-5 py-[15px] bg-signal text-white font-semibold hover:bg-signal-hover active:bg-signal-active`,
  outline:
    `${base} rounded-input px-5 py-[15px] border border-signal/20 text-signal bg-surface-muted hover:bg-sky-wash`,
  ghost:
    `${base} rounded-pill px-8 py-3.5 border border-signal/25 text-signal bg-linen-canvas hover:border-signal/40 hover:bg-surface-muted`,
};

export default function SaasButton({
  as: Tag = 'button',
  variant = 'outline',
  to,
  href,
  className = '',
  children,
  ...rest
}) {
  const cls = `${variants[variant] || variants.outline} ${className}`.trim();

  if (to) {
    return (
      <Link to={to} className={cls} {...rest}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={cls} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <Tag className={cls} {...rest}>
      {children}
    </Tag>
  );
}
